export const BLOG_URL = '/blog';
export const CASE_STUDIES_URL = '/case-studies';
export const BLOG_AUTHOR_URL = '/blog/author';
export const WEBINAR_URL = '/webinars';
